// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PharmacyBiResultSearchResponse } from './pharmacyBiResultSearchResponse.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PharmacyV1PharmacyBiResultSearchPharmacyV1PharmacyBiResultSearchDefaultResponse {
    'success': boolean;
    'messages': Array<string>;
    'data': PharmacyBiResultSearchResponse | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PharmacyV1PharmacyBiResultSearchPharmacyV1PharmacyBiResultSearchDefaultResponse>> = [
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
        {
            "name":     "data",
            "baseName": "data",
            "type":     "PharmacyBiResultSearchResponse"
        },
    ];

    static getAttributeTypeMap() {
        return PharmacyV1PharmacyBiResultSearchPharmacyV1PharmacyBiResultSearchDefaultResponse.attributeTypeMap;
    }
}
